import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { SimilarPosts } from 'components/blog';
import { SimilarPostsFactory } from './SimilarPostsFactory';

const SimilarPostsContainer = (props) => (
  <StaticQuery
    query={graphql`
      query SimilarPosts {    
        gcms {
          posts(orderBy: date_DESC) {
            id
            title
            subtitle
            slug
            date
            category {
              name
              slug
            }
            tags {
              name
              slug
            }
            coverImage {
              url
            }
          }
        }
      }
    `}
    render={data => {
      const {
        category,
        tags,
        currentPostSlug
      } = props;
      const { posts } = data.gcms;

      let similarPosts;

      if (category === 'reinvent') {
        // Return only reinvent posts with the same tag for the reinvent blog
        const postsWithTags = posts.filter(post => post.tags.length > 0);
        similarPosts = postsWithTags.filter(post => post.tags[0].slug === tags[0] && post.slug !== currentPostSlug);
      } else {
        // Use a SimilarPostsFactory to get similar posts for all other posts
        similarPosts = new SimilarPostsFactory(
          posts, currentPostSlug
        )
          .setMaxPosts(2)
          .setCategory(category)
          .setTags(tags)
          .getPosts();
      }

      // Render it
      return (
        <SimilarPosts
          posts={similarPosts}
        />
      );
    }}
  />
);

export default SimilarPostsContainer;

SimilarPostsContainer.propTypes = {
  category: PropTypes.string,
  currentPostSlug: PropTypes.string.isRequired,
  tags: PropTypes.array
};
